import React, { useState, useEffect, useRef } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  AESEncryption,
  ApiResDecrypt,
} from "../../CommonMethhods/CommonMethods";
import axios from "axios";
import { Client_Search, IPO_Document } from "../../Configuration/API_URL";
import $ from "jquery";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import { toast } from "react-toastify";
import CustomSelect from "./IPOCustomSelect";
import SmallLoader from "../../Components/Common/smallLoader";

export default function IPODocument(props) {
  const storeToken = localStorage.getItem("ssoToken");

  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [clientName, setClientName] = useState("");
  const [show, setShow] = useState(false);
  const [clientCode, setClientCode] = useState("");
  const [selectedClientCode, setSelectedClientCode] = useState("");
  const [scroll, setScroll] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [investorStatusOptions, setInvestorStatusOptions] = useState([]);
  const [ipoNameSbCodeOptions, setIpoNameSbCodeOptions] = useState([]);
  const [sbCodeOptions, setSbCodeOptions] = useState([]);
  const [ipoNameOptions, setIpoNameOptions] = useState([]);
  const [dpOptions, setDpOptions] = useState(["NSDL", "CDSL"]);
  const [ipoDetails, setIpoDetails] = useState();
  const [tableData, setTableData] = useState([]);
  const [pan, setPan] = useState("");
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [resett, setResett] = useState(false);
  const [generateLoader, setGenerateLoader] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [downloadId, setDownloadId] = useState(null);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [initialQty, setInitialQty] = useState(0);
  const [priceRange, setPriceRange] = useState("");
  const [priceCap, setPriceCap] = useState();
  const [minPrice, setMinPrice] = useState();
  const [priceError, setPriceError] = useState("");
  const inputRefs = useRef({});

  const schema = yup.object().shape({
    clientCode: yup.string().required("Client Code is required").nullable(),
    ipoName: yup
      .string()
      .required("IPO Name is required")
      .oneOf(ipoNameOptions, "Please select a valid IPO Name"),
    // sbCode: yup
    //   .string()
    //   .required("SB Code is required")
    //   .oneOf(sbCodeOptions, "Please select a valid SB Code"),
    investor: yup
      .string()
      .required("Investor Name is required")
      .max(60, "Investor cannot exceed 60 characters"),
    dp: yup
      .string()
      .required("DP is required")
      .oneOf(dpOptions, "Please select a valid DP"),
    category: yup
      .string()
      .required("Category is required")
      .oneOf(categoryOptions, "Please select a valid Category"),
    investorStatus: yup
      .string()
      .required("Investor Status is required")
      .oneOf(investorStatusOptions, "Please select a valid Investor status"),
    pan: yup.string().required("PAN is required"),
    fullDPID: yup
      .string()
      .required("DP CLIT ID is required")
      .max(16, "DP CLIT ID cannot exceed 16 characters"),
    address: yup
      .string()
      .required("Address is required")
      .max(200, "Address cannot exceed 200 characters"),
    bank: yup
      .string()
      .required("Bank is required")
      .max(50, "Bank cannot exceed 50 characters"),
    branch: yup
      .string()
      .required("Branch is required")
      .max(50, "Branch cannot exceed 60 characters"),
    bankAccountNo: yup
      .string()
      .required("Bank Account Number is required")
      .max(25, "Account No. cannot exceed 25 characters"),
    mobile: yup
      .string()
      .required("Mobile Number is required")
      .length(10, "Mobile Number must be 10 digits long"),
    email: yup
      .string()
      .email("Invalid email")
      .required("Email is required")
      .max(50, "Email cannot exceed 50 characters"),
    qty: yup
      .string()
      .required("Quantity is required")
      .max(16, "Quantity cannot exceed 16 digits"),
    price: yup.string().required("Price is required"),

    amount: yup
      .string()
      .required("Amount is required")
      .max(16, "Amount cannot exceed 16 characters"),
    // rmCode: yup
    //   .string()
    //   .required("RM Code is required")
    //   .max(30, "RM Code cannot exceed 30 characters"),
  });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  useEffect(() => {
    if (setResett !== false) setResett(false);
  }, [resett]);

  const sanitizeAlphaNumValue = (value) => {
    let v = value.toUpperCase();
    v = v.replace(/[^A-Z0-9 ]/gi, "");
    v = v.replace(/\s{2,}/g, " ");
    v = v.replace(/^\s+/, "");
    return v;
  };

  const sanitizeAlphaValue = (value) => {
    let v = value.toUpperCase();
    v = v
      .replace(/[^A-Z\s]/g, "")
      .replace(/\s+/g, " ")
      .trimStart();
    return v;
  };

  const sanitizePrice = (value) => {
    value = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");

    // Allow empty string
    if (value === "") {
      setPriceError("");
      return "";
    }

    // If all zeros, keep single zero
    if (/^0+$/.test(value)) {
      setPriceError("Enter price within Price range");
      return "0";
    }

    // If it starts with ".", prepend 0
    if (value.startsWith(".")) {
      value = "0" + value;
    }

    // Strip leading zeros if followed by other digits (09 → 9, 0012 → 12)
    if (/^0+\d/.test(value)) {
      value = value.replace(/^0+/, "");
    }

    const num = Number(value);
    console.log(num, "nummmmPP");
    if (num > priceCap || num < minPrice) {
      setPriceError("Enter price within Price range");
    } else {
      setPriceError("");
    }

    return value;
  };

  const sanitizeQty = (value) => {
    value = value.replace(/[^0-9]/g, "");

    // Allow empty string (so user can clear input)
    if (value === "") return "";

    // Remove leading zeros but allow single "0"
    value = value.replace(/^0+/, "");
    if (value === "") return "0";

    return value;
  };

  const sanitizeDigits = (value) => {
    value = value.replace(/\D/g, "");
    return value;
  };

  const sanitizeMobile = (value) => {
    let digits = value.replace(/\D/g, "");
    if (!/^[6-9]/.test(digits)) return "";
    return digits;
  };

  const sanitizeEmail = (value) => {
    value = value.replace(/\s+/g, "");
    return value;
  };

  const sanitizeAddress = (value) => {
    let v = value.toUpperCase();
    v = v
      .replace(/[^A-Za-z0-9#.,'&()/\- ]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/, "");
    return v;
  };

  const onSubmit = (data) => {
    saveIpoDocument(data);
  };

  const handleClientCode = (e) => {
    setShow(true);
    setScrollLoader(false);
    if (e.target.value) {
      setClientList([]);
      setScroll(false);
      let value = e.target.value.toUpperCase();
      value = value.replace(/[^A-Z0-9 ]/gi, "");
      value = value.replace(/\s{2,}/g, " ");
      value = value.replace(/^\s+/, "");
      setClientCode(value);

      if (e.target.value.length > 3) {
        setPage(1);
        setClientList([]);
        setScroll(false);
        searchApiDetail(e.target.value);
      }
    } else {
      setClientList([]);
      setPage(1);
      setClientName("");
      setClientCode("");
      setSelectedClientCode("");

      setScroll(false);
      $(".write-search.dividen").removeClass("show-result");
    }
    $(".write-search.dividen-li").click(function () {
      $(".write-search.dividen").addClass("show-result scroll-table");
    });
  };

  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector("#dividend-scroll");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setPage((prev) => prev + 1);
      setScrollLoader(true);

      searchApiDetail(clientCode);
    }
  };

  async function searchApiDetail(e) {
    $(".write-search.dividen").addClass("show-result scroll-table");
    let payloadValue = {
      keyword: e.toUpperCase(),
      Status: "",
      PageNo: page,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        Client_Search.Search_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      if (res.message === "Client does not exist.") {
        setClientList([
          { clientname: "Client does not exist.", clientCode: null },
        ]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.clients];
          });
        } else {
          setClientList(res.data.clients);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setScrollLoader(false);
    }
  }

  const getCategory = async () => {
    setLoading(true);
    try {
      let res = await axios.get(IPO_Document.Get_IPO_Category, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${storeToken}`,
          reserv: 1,
        },
      });
      res = ApiResDecrypt(res.data);
      if (res.status === 0) {
        console.log(res.data, "category");
        setCategoryOptions(res.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getInvestorStatus = async () => {
    setLoading(true);
    try {
      let res = await axios.get(IPO_Document.Get_Investor_Status, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${storeToken}`,
          reserv: 1,
        },
      });
      res = ApiResDecrypt(res.data);
      if (res.status === 0) {
        setInvestorStatusOptions(res.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getIponameSbcode = async () => {
    setLoading(true);
    const payloadvalue = {
      pan,
    };
    const encPayload = AESEncryption(payloadvalue);
    try {
      let res = await axios.post(
        IPO_Document.Get_IPOName_SBCode,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      res = ApiResDecrypt(res.data);
      if (res.status === 0) {
        const ipoNames = res.data.map((item) => item.IPOName);
        const sbCodes = res.data.map((item) => item.SBCode);
        console.log(res, "res");

        setIpoNameOptions(ipoNames);
        setSbCodeOptions(sbCodes);
        setIpoNameSbCodeOptions(res.data);
      } else {
        setIpoNameOptions([]);
        setSbCodeOptions([]);
        setIpoNameSbCodeOptions([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  console.log(ipoNameOptions, sbCodeOptions, "sbCodeOptions");

  const fetchIpoDetails = async () => {
    const payloadvalue = {
      clientCode: selectedClientCode,
    };
    const encPayload = AESEncryption(payloadvalue);
    try {
      let res = await axios.post(
        IPO_Document.Fetch_IPO_Details,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      res = ApiResDecrypt(res.data);
      console.log(res);
      if (res.status === 0) {
        console.log(res.data, "ipo details");
        setIpoDetails(res.data);
        setValue("investor", res.data.Investor || "");
        setValue("dp", res.data.DP || "");
        setValue("pan", res.data.PAN || "");
        setValue("fullDPID", res.data.DPCLITID || "");
        setValue("address", res.data.Address || "");
        // setValue("bank", res.data.Bank || "");
        // setValue("branch", res.data.Branch || "");
        // setValue("bankAccountNo", res.data.BankAccountNumber || "");
        setValue("mobile", res.data.MobileNumber || "");
        setValue("email", res.data.Email || "");
        setValue("rmCode", res.data.RMCode || "");
        setValue("price", "");
        setValue("qty", 0);
        setValue("category", "");
        setValue("investorStatus", "");
        setValue("sbCode", "");
        setValue("ipoName", "");
        setPan(res.data.PAN);
        setResett(true);
        trigger();
      } else if (res.status === 1) {

        reset();
        setResett(true);
        setInitialQty(0);
        setPriceRange("");
        setPriceError("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const saveIpoDocument = async (data) => {
    if (priceError) return;
    setSaveLoading(true);
    const payloadvalue = {
      ...data,
      qty: Number(data.qty),
      amount: Number(data.amount),
      price: Number(data.price),
      sendEmail: "",
      status: "",
    };
    const encPayload = AESEncryption(payloadvalue);
    try {
      let res = await axios.post(
        IPO_Document.Save_IPO_Document,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      res = ApiResDecrypt(res.data);
      if (res.status === 0) {
        toast.success("Document Saved Successfully");
        getIpoTable();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSaveLoading(false);
    }
  };

  const getIpoTable = async () => {
    const payloadvalue = {
      clientCode: selectedClientCode,
    };
    const encPayload = AESEncryption(payloadvalue);
    try {
      let res = await axios.post(
        IPO_Document.Get_IPODoc_Grid,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      res = ApiResDecrypt(res.data);
      if (res.status === 0) {
        setTableData(res.data);
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDownloadDoc = async (id, docName) => {
    setDownloadLoader(true);
    setDownloadId(id);
    const payloadvalue = {
      id,
      docName,
    };
    const encPayload = AESEncryption(payloadvalue);
    try {
      let res = await axios.post(
        IPO_Document.Download_IPODocument,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      res = ApiResDecrypt(res.data);
      if (res.status === 0) {
        window.open(res?.data, "_blank", "noopener,noreferrer");
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadLoader(false);
    }
  };

  const handleGenerateDoc = async (item) => {
    setGenerateLoader(true);
    setLoadingIndex(item.Id);
    const payloadvalue = {
      id: item.Id,
      ipoName: item.SBCode,
      sbCode: "",
      investor: item.Investor,
      category: item.Category,
      pan: item.PAN,
      fullDPID: item.FullDPID,
      address: item.Address,
      bank: item.Bank,
      branch: item.Branch,
      bankAccountNo: item.BankAccountNo,
      mobile: item.Mobile,
      email: item.Email,
      qty: item.Qty,
      price: item.Price,
      amount: item.Amount,
      rmCode: item.RMCode,
    };
    const encPayload = AESEncryption(payloadvalue);
    try {
      let res = await axios.post(
        IPO_Document.Generate_IPODocument,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      res = ApiResDecrypt(res.data);
      if (res.status === 0) {
        toast.success("IPO Document generated successfully");
        getIpoTable();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setGenerateLoader(false);
    }
  };

  const extractRange = (str) => {
    if (str) {
      const range = str.match(/\d+/g)?.map(Number);
      const maxRange = range.length === 1 ? range[0] : range[1];
      const minRange = range.length === 1 ? 1 : range[0];
      setPriceCap(() => maxRange);
      setMinPrice(() => minRange);
      trigger("price");
    }
  };

  const selectedIpoName = watch("ipoName");
  const selectedSbCode = watch("sbCode");
  const price = watch("price");
  const qty = watch("qty");
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);

  useEffect(() => {
    if (!selectedIpoName && !selectedSbCode) {
      setValue("price", "");
      setValue("qty", 0);
    }
  }, [selectedIpoName, selectedSbCode]);

  useEffect(() => {
    getCategory();
    getInvestorStatus();
  }, []);

  useEffect(() => {
    fetchIpoDetails();
    getIpoTable();
    fetchBankDetails()
  }, [selectedClientCode]);

  useEffect(() => {
    getIponameSbcode();
  }, [pan]);

  const fetchBankDetails = async () => {
    const payloadvalue = {
      clientCode: selectedClientCode,
    };
    const encPayload = AESEncryption(payloadvalue);

    try {
      let res = await axios.post(
        // "https://uat-cosmos.bajajfinservsecurities.in/api/rm/IPO/bankdetailsforipo",
        IPO_Document.BankDetailsForIPO,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      res = ApiResDecrypt(res.data);

      if (res.status === 0 && Array.isArray(res.data)) {
        const bankData = res.data;
        console.log(bankData, "bankData");
        setBankList(bankData);

        let defaultBank = null;

        // ✅ CASE 1: Only one bank → auto select it
        if (bankData.length === 1) {
          defaultBank = bankData[0];
        }
        // ✅ CASE 2: Multiple banks → find the one marked as default
        else {
          defaultBank = bankData.find((b) => b.def === "1");
        }

        // ✅ If any valid bank is found, auto fill form fields
        if (defaultBank) {
          setSelectedBank(defaultBank);
          setValue("bank", defaultBank.bank);
          setValue("branch", defaultBank.branch);
          setValue("bankAccountNo", defaultBank.bankAccountNo);
          setValue("ifsc", defaultBank.ifsc || "");
        }
      } else {
        // 🧹 Reset if response invalid
        reset();
        setResett(true);
        setInitialQty(0);
        setPriceRange("");
        setPriceError("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (selectedIpoName) {
      const match = ipoNameSbCodeOptions.find(
        (item) => item.IPOName === selectedIpoName
      );
      if (match) {
        setValue("sbCode", match.SBCode);
        setValue("price", match.MinPrice);
        setPriceError("");
        setValue("qty", match.Quantity);
        setInitialQty(match.Quantity);
        setPriceRange(match.PriceRange);
        extractRange(match.PriceRange);
        trigger(["sbCode", "price", "qty"]);
      }
    }
  }, [selectedIpoName]);

  // useEffect(() => {
  //   debugger
  //   if (selectedSbCode) {
  //     const match = ipoNameSbCodeOptions.find(
  //       (item) => item.SBCode === selectedSbCode
  //     );
  //     if (match) {
  //       setValue("ipoName", match.IPOName);
  //       setValue("price", match.Price);
  //       setValue("qty", match.Quantity);
  //       trigger(["ipoName", "price", "qty"]);
  //     }
  //   }
  // }, [selectedSbCode]);
  // useEffect(() => {
  //   if (selectedSbCode && ipoNameSbCodeOptions.length > 0) {
  //     const match = ipoNameSbCodeOptions.find(
  //       (item) => item.SBCode === selectedSbCode
  //     );
  //     if (match) {
  //       const price = Number(match.Price);
  //       const lotSize = Number(match.Quantity) || 1;
  //       const minAmount = 500000; // ₹5 lakh minimum

  //       // Calculate minimum quantity required to meet 5 lakh
  //       const minQtyRequired = Math.ceil(minAmount / price);

  //       // Use higher of lotSize or minQtyRequired
  //       const qtyToSet = Math.max(lotSize, minQtyRequired);

  //       setValue("ipoName", match.IPOName);
  //       setValue("price", match.Price);
  //       setValue("qty", qtyToSet);
  //       setInitialQty(lotSize); // keep the original lot size
  //       trigger(["ipoName", "price", "qty"]);
  //     }
  //   }
  // }, [selectedSbCode, ipoNameSbCodeOptions]);


  // useEffect(() => {
  //   if (selectedSbCode) {
  //     const match = ipoNameSbCodeOptions.find(
  //       (item) => item.SBCode === selectedSbCode
  //     );
  //     if (match) {
  //       const price = Number(match.Price);
  //       const lotSize = Number(match.Quantity) || 1;
  //       const minAmount = 500000; // ₹5 lakh minimum

  //       // Calculate minimum quantity required to meet 5 lakh
  //       const minQtyRequired = Math.ceil(minAmount / price);

  //       // Use higher of lotSize or minQtyRequired
  //       const qtyToSet = Math.max(lotSize, minQtyRequired);

  //       setValue("ipoName", match.IPOName);
  //       setValue("price", match.Price);
  //       setValue("qty", qtyToSet);
  //       setInitialQty(lotSize); // keep the original lot size
  //       trigger(["ipoName", "price", "qty"]);
  //     }
  //   }
  // }, [selectedSbCode]);

  const selectedCategory = watch("category");

  useEffect(() => {
    if (!selectedIpoName && !selectedSbCode) return; // do nothing if IPO not selected

    const selectedIPO = ipoNameSbCodeOptions.find(
      (item) => item.IPOName === selectedIpoName || item.SBCode === selectedSbCode
    );
    if (!selectedIPO) return;

    const price = Number(selectedIPO.MinPrice);
    const lotSize = Number(selectedIPO.Quantity) || 1;

    let newQty = lotSize;
    let newAmount = price * lotSize;

    if (selectedCategory === "SME") {
      // Default 2 lots for SME
      newQty = 2 * lotSize;
      newAmount = newQty * price;
    } else {
      // Non-SME, apply ₹5 lakh minimum logic
      const minQtyRequired = Math.ceil(500000 / price);
      newQty = Math.max(lotSize, minQtyRequired);
      newAmount = newQty * price;
    }

    setValue("qty", newQty);
    setValue("amount", newAmount);
    trigger(["qty", "amount"]);
  }, [selectedCategory, selectedIpoName, selectedSbCode]);


  useEffect(() => {
    const amt = qty * price;
    setValue("amount", amt || 0);
  }, [qty, price]);
  // const extractRange = (rangeStr) => {
  //   if (!rangeStr) return { min: null, max: null };

  //   const match = rangeStr.match(/(\d+)-(\d+)/);
  //   if (!match) return { min: null, max: null };

  //   return {
  //     min: Number(match[1]),
  //     max: Number(match[2]),
  //   };
  // };

  return (
    <div>
      <Header title={props.title} portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="mutualfunds ">
        <div className="tab-content card-box" id="mainTabContent">
          <div>
            <h2>IPO Physical Form Download</h2>
          </div>
          <div className="mt-5">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row input-field-wrapper">
                {/* Custom Client Code Dropdown using Controller */}
                <Controller
                  name="clientCode"
                  control={control}
                  render={({ field, fieldState }) => (
                    <div className="col-md-3 col-sm-4 col-12">
                      <div className="form-group">
                        <label className="form-label">
                          Client Code
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-text-wrapper align-items-center">
                          <input
                            id="input1"
                            type="text"
                            className={`input-text form-control ${fieldState.error ? "is-invalid" : "mb-4"
                              }`}
                            placeholder="Search by Name/ Code"
                            value={clientCode}
                            onChange={(e) => {
                              handleClientCode(e);
                            }}
                            onBlur={field.onBlur}
                            onInput={(e) => {
                              const start = e.target.selectionStart;
                              const end = e.target.selectionEnd;
                              let input = e.target.value;
                              input = input
                                .toUpperCase()
                                .replace(/[^A-Z0-9\s]/g, "")
                                .replace(/\s+/g, " ")
                                .trimStart()
                                .slice(0, 100);

                              e.target.value = input;
                              e.target.setSelectionRange(start, end);

                            }}
                          />

                          <ul
                            className="write-search dividen border-0"
                            id="dividend-scroll"
                            onScroll={handleScroll}
                          >
                            {show &&
                              clientList.map((item, i) => (
                                <li
                                  key={i}
                                  onClick={() => {
                                    setClientCode(item.clientCode || "");
                                    setSelectedClientCode(item.clientCode);
                                    field.onChange(item.clientCode);
                                    setShow(false);
                                  }}
                                >
                                  <div>{item.clientname}</div>
                                  <div>{item.clientCode}</div>
                                </li>
                              ))}
                            {scrollLoader && (
                              <div className="loader-center">
                                <LoaderForSearch />
                              </div>
                            )}
                          </ul>
                        </div>
                        {fieldState.error && (
                          <div className="invalid-feedback d-block">
                            {fieldState.error.message}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                />

                {[
                  {
                    name: "ipoName",
                    label: "IPO Name",
                    options: ipoNameOptions,
                  },
                  // { name: "sbCode", label: "SB Code", options: sbCodeOptions },
                  {
                    name: "investor",
                    label: "Investor",
                    sanitizeValue: sanitizeAlphaValue,
                  },
                  {
                    name: "dp",
                    label: "DP",
                    options: dpOptions,
                  },
                  {
                    name: "category",
                    label: "Category",
                    options: categoryOptions,
                  },
                  {
                    name: "investorStatus",
                    label: "Investor Status",
                    options: investorStatusOptions,
                  },
                  { name: "pan", label: "PAN" },
                  {
                    name: "fullDPID",
                    label: "DP Client ID",
                    sanitizeValue: sanitizeAlphaNumValue,
                  },
                  {
                    name: "address",
                    label: "Address",
                    sanitizeValue: sanitizeAddress,
                  },
                  {
                    name: "bank",
                    label: "Bank",
                    sanitizeValue: sanitizeAlphaValue,
                  },
                  {
                    name: "branch",
                    label: "Branch",
                    sanitizeValue: sanitizeAlphaNumValue,
                  },
                  {
                    name: "bankAccountNo",
                    label: "Bank Account Number",
                    sanitizeValue: sanitizeDigits,
                  },
                  {
                    name: "mobile",
                    label: "Mobile Number",
                    sanitizeValue: sanitizeMobile,
                  },
                  {
                    name: "email",
                    label: "Email",
                    sanitizeValue: sanitizeEmail,
                  },
                  {
                    name: "qty",
                    label: "Quantity",
                    sanitizeValue: sanitizeQty,
                  },
                  {
                    name: "price",
                    label: "Price",
                    sanitizeValue: sanitizePrice,
                  },
                  {
                    name: "amount",
                    label: "Amount",
                  },
                  // {
                  //   name: "rmCode",
                  //   label: "RM Code",
                  //   sanitizeValue: sanitizeAlphaNumValue,
                  // },
                ].map((field, i) => {
                  if (field.name === "qty") {
                    return (
                      <div className="col-md-3 col-sm-3 col-6" key={i}>
                        <div className="form-group">
                          <label className="form-label">
                            {field.label}
                            {initialQty !== 0 &&
                              (selectedIpoName || selectedSbCode) && (
                                <span
                                  style={{ color: "gray", fontSize: "10px" }}
                                >
                                  {" "}
                                  (Lot size: {initialQty})
                                </span>
                              )}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="input-group">
                            <button
                              type="button"
                              disabled={!(selectedIpoName || selectedSbCode)}
                              className={`btn btn-ipo-qty ${errors["qty"] ? "" : "mb-4"}`}
                              onClick={() => {
                                const currentVal = Number(qty);

                                const selectedIPO = ipoNameSbCodeOptions.find(
                                  (item) => item.IPOName === selectedIpoName || item.SBCode === selectedSbCode
                                );
                                if (!selectedIPO) return;

                                const price = Number(selectedIPO.MinPrice);
                                const lotSize = Number(selectedIPO.Quantity) || 1;
                                const minAmount = 500000;

                                let newVal;

                                if (selectedCategory === "SME") {
                                  // For SME, quantity cannot go below 2 lots
                                  newVal = currentVal > 2 * lotSize ? currentVal - lotSize : 2 * lotSize;
                                } else {
                                  // Existing ₹5 lakh minimum logic
                                  const minQtyRequired = Math.ceil(minAmount / price);
                                  newVal = currentVal > lotSize
                                    ? Math.max(currentVal - lotSize, minQtyRequired)
                                    : Math.max(lotSize, minQtyRequired);
                                }

                                const newAmount = newVal * price;

                                setValue("qty", newVal);
                                setValue("amount", newAmount);
                                trigger(["qty", "amount"]);
                              }}
                            >
                              -
                            </button>


                            <input
                              type="text"
                              readOnly
                              className={`form-control text-center mx-1 ${errors["qty"] ? "is-invalid" : "mb-4"
                                }`}
                              value={
                                selectedIpoName || selectedSbCode ? qty || 0 : 0
                              }
                            />

                            <button
                              type="button"
                              disabled={!(selectedIpoName || selectedSbCode)}
                              className={`btn btn-ipo-qty ${errors["qty"] ? "" : "mb-4"}`}
                              onClick={() => {
                                const currentVal = Number(qty);

                                const selectedIPO = ipoNameSbCodeOptions.find(
                                  (item) => item.IPOName === selectedIpoName || item.SBCode === selectedSbCode
                                );
                                if (!selectedIPO) return;

                                const price = Number(selectedIPO.MinPrice);
                                const lotSize = Number(selectedIPO.Quantity) || 1;

                                let newVal;

                                if (selectedCategory === "SME") {
                                  // For SME, increment by 1 lot each time
                                  newVal = currentVal === 0 ? 2 * lotSize : currentVal + lotSize;
                                } else {
                                  // Existing ₹5 lakh minimum logic
                                  newVal = currentVal === 0 ? Math.ceil(500000 / price) : currentVal + lotSize;
                                }

                                const newAmount = newVal * price;

                                setValue("qty", newVal);
                                setValue("amount", newAmount);
                                trigger(["qty", "amount"]);
                              }}
                            >
                              +
                            </button>

                          </div>
                          {errors["qty"] && (
                            <div className="invalid-feedback d-block">
                              {errors["qty"].message}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }
                  if (field.name === "bank") {
                    return (
                      <div className="col-md-3 col-sm-3 col-6" key={i}>
                        <div className="form-group">
                          <label className="form-label">
                            {field.label} <span style={{ color: "red" }}>*</span>
                          </label>
                          <select
                            className="form-control mb-4"
                            value={selectedBank?.bank || ""}
                            onChange={(e) => {
                              const selected = bankList.find(b => b.bank === e.target.value);
                              if (selected) {
                                setSelectedBank(selected);
                                setValue("bank", selected.bank);
                                setValue("branch", selected.branch);
                                setValue("bankAccountNo", selected.bankAccountNo);
                                setValue("ifsc", selected.ifsc || "");
                              }
                            }}
                          >
                            {/* <option value="">Select Bank</option> */}
                            {bankList.map((b, index) => (
                              <option key={index} value={b.bank}>
                                {b.bank}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    );
                  }

                  if (
                    field.name === "ipoName" ||
                    field.name === "sbCode" ||
                    field.name === "category" ||
                    field.name === "investorStatus" 
                    // ||
                    // field.name === "dp"
                  ) {
                    return (
                      <CustomSelect
                        name={field.name}
                        label={field.label}
                        control={control}
                        options={field.options}
                        loading={loading}
                        resett={resett}
                      />
                    );
                  } else {
                    return (
                      <div className="col-md-3 col-sm-3 col-6" key={i}>
                        <div className="form-group">
                          <label className="form-label">
                            {field.label}
                            {field.name === "price" &&
                              priceRange &&
                              (selectedIpoName || selectedSbCode) && (
                                <span
                                  style={{ color: "gray", fontSize: "10px" }}
                                >
                                  {" "}
                                  (Price Range: {priceRange})
                                </span>
                              )}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          {/* get register props once so we can reuse ref & onBlur */}
                          {(() => {
                            const reg = register(field.name);
                            const currentVal = watch(field.name);
                            return (
                              <input
                                type="text"
                                placeholder={`Please enter ${field.label}`}
                                className={`form-control ${(field.name === "price" && priceError) ||
                                  errors[field.name]
                                  ? "is-invalid"
                                  : "mb-4"
                                  }`}
                                value={currentVal ?? ""}
                                //spread other register props (onBlur, name) but we override ref & onChange 
                                {...reg}
                                ref={(el) => {
                                  // attach RHF's ref and keep a local reference for caret restore
                                  reg.ref(el);
                                  inputRefs.current[field.name] = el;
                                }}


                                onChange={(e) => {
                                  const raw = e.target.value ?? "";
                                  let next = raw.replace(/[^\d]/g, "");

                                  // If blank, clear error and let RHF show required error
                                  if (next === "") {
                                    setPriceError("");
                                    setValue(field.name, "", { shouldValidate: true });
                                    return;
                                  }

                                  const numeric = Number(next);

                                  // Min check
                                  if (numeric < minPrice) {
                                    setPriceError(`Price cannot be less than ₹${minPrice}`);
                                  }
                                  // Max check
                                  else if (numeric > priceCap) {
                                    setPriceError(`Price cannot be more than ₹${priceCap}`);
                                  }
                                  else {
                                    setPriceError(""); // valid value
                                  }

                                  setValue(field.name, next, {
                                    shouldDirty: true,
                                    shouldValidate: true,
                                  });
                                }}

                                // disabled={
                                //   field.name === "pan" ||
                                //   field.name === "amount" ||
                                //   field.name === "rmCode"
                                // }
                                disabled={[
                                  "investor",
                                  "dp",
                                  "fullDPID",
                                  "address",
                                  "branch",
                                  "bankAccountNo",
                                  "mobile",
                                  "email",
                                  "pan",
                                  "amount",
                                  "rmCode"
                                ].includes(field.name)}
                              />
                            );
                          })()}

                          {errors[field.name] && !priceError && (
                            <div className="invalid-feedback">{errors[field.name].message}</div>
                          )}

                          {priceError && (
                            <div className="invalid-feedback">{priceError}</div>
                          )}
                        </div>
                      </div>
                    );
                  }
                })}
              </div>

              <div className="ipo-btn-wrapper">
                <button
                  type="button"
                  className="btn-reset mr-3"
                  onClick={() => {
                    setResett(true);
                    reset();
                    setClientCode("");
                    setSelectedClientCode("");
                    setInitialQty(0);
                    setPriceRange("");
                    setPriceError("");
                  }}
                >
                  Reset
                </button>

                <button
                  className="btn-save"
                  type={saveLoading ? "button" : "submit"}
                >
                  {saveLoading ? (
                    <div
                      className="d-flex justify-content-center"
                      style={{ color: "white" }}
                    >
                      <SmallLoader />
                    </div>
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </form>
            {tableData?.length > 0 ? (
              <div className="mt-5 ipo-table-container">
                <table className="ipo-table">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center">
                        Sr No.
                      </th>
                      <th scope="col" className="text-center">
                        Client Code
                      </th>
                      <th scope="col" className="text-center">
                        IPO Name
                      </th>
                      <th scope="col" className="text-center">
                        SB Code
                      </th>
                      <th scope="col" className="text-center">
                        Investor
                      </th>
                      <th scope="col" className="text-center">
                        DP
                      </th>
                      <th scope="col" className="text-center">
                        Category
                      </th>
                      <th scope="col" className="text-center">
                        Investor Status
                      </th>
                      <th scope="col" className="text-center">
                        PAN
                      </th>
                      <th scope="col" className="text-center">
                        DP CLIT ID
                      </th>
                      <th scope="col" className="text-center">
                        Address
                      </th>
                      <th scope="col" className="text-center">
                        Bank
                      </th>
                      <th scope="col" className="text-center">
                        Branch
                      </th>
                      <th scope="col" className="text-center">
                        Bank Acc Number
                      </th>
                      <th scope="col" className="text-center">
                        Mobile Number
                      </th>
                      <th scope="col" className="text-center">
                        Email Address
                      </th>
                      <th scope="col" className="text-center">
                        Quantity
                      </th>
                      <th scope="col" className="text-center">
                        Price
                      </th>
                      <th scope="col" className="text-center">
                        Amount
                      </th>
                      <th scope="col" className="text-center">
                        RM Code
                      </th>
                      <th scope="col" className="text-center">
                        Document
                      </th>
                      <th scope="col" className="text-center">
                        Document
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((item, idx) => {
                      return (
                        <tr key={item.Id}>
                          <td>{idx + 1}</td>
                          <td>{item.ClientCode}</td>
                          <td>{item.IPOName}</td>
                          <td>{item.SBCode}</td>
                          <td>{item.Investor}</td>
                          <td>{item.DP}</td>
                          <td>{item.Category}</td>
                          <td>{item.InvestorStatus}</td>
                          <td>{item.PAN}</td>
                          <td>{item.FullDPID}</td>
                          <td className="wrap-text">{item.Address}</td>
                          <td>{item.Bank}</td>
                          <td>{item.Branch}</td>
                          <td>{item.BankAccountNo}</td>
                          <td>{item.Mobile}</td>
                          <td>{item.Email}</td>
                          <td>{item.Qty}</td>
                          <td>{item.Price}</td>
                          <td>{item.Amount}</td>
                          <td>{item.RMCode}</td>
                          <td>
                            <div className="ipo-btn-wrapper">
                              <button
                                style={{ width: "75px", height: "28px" }}
                                className="btn-save"
                                disabled={item.FileStatus === "Generated"}
                                onClick={() => handleGenerateDoc(item)}
                              >
                                {generateLoader && item.Id === loadingIndex ? (
                                  <div
                                    className="d-flex justify-content-center"
                                    style={{ color: "white" }}
                                  >
                                    <SmallLoader />
                                  </div>
                                ) : item.FileStatus === "Generated" ? (
                                  "Generated"
                                ) : (
                                  "Generate"
                                )}
                              </button>
                            </div>
                          </td>
                          <td>
                            <div className="ipo-btn-wrapper">
                              <button
                                style={{ width: "75px", height: "28px" }}
                                className="btn-save"
                                onClick={() =>
                                  handleDownloadDoc(item.Id, item.DocName)
                                }
                                disabled={item.FileStatus !== "Generated"}
                              >
                                {downloadLoader && item.Id === downloadId ? (
                                  <div
                                    className="d-flex justify-content-center"
                                    style={{ color: "white" }}
                                  >
                                    <SmallLoader />
                                  </div>
                                ) : (
                                  "Download"
                                )}
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}{" "}
                  </tbody>
                </table>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
